/* global chrome */
// IMPORTANT: custom-elements polyfill must be imported BEFORE the Appcues SDK.
// Content scripts don't natively support Custom Elements — skipping this breaks
// Pins experience type and preview mode.
import '@webcomponents/custom-elements';
import Appcues from '@appcues/web-sdk';

const APPCUES_ACCOUNT_ID = '225838';

export async function initAppcues() {
  try {
    // The extension must serve Appcues assets locally (MV3 bans remote scripts),
    // so it sets assetsPath from the packaged extension URL. This module is also
    // copied into the embed (iframe web page) and Electron, where there is no
    // chrome.runtime — there we omit assetsPath and let the SDK load its assets
    // from the Appcues CDN, which those contexts allow.
    const options =
      typeof chrome !== 'undefined' && chrome.runtime?.getURL
        ? { assetsPath: chrome.runtime.getURL('static/appcues') }
        : {};
    await Appcues.setup(APPCUES_ACCOUNT_ID, options);
    console.log('Appcues: Initialized');
  } catch (error) {
    console.error('Appcues: Initialization failed', error);
  }
}
